import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VeeValidate from "vee-validate";
import Buefy from "buefy";

require("./assets/main.scss");

Vue.use(Buefy);
Vue.use(VeeValidate, { inject: false });

Vue.config.productionTip = false;
if (process.env.NODE_ENV !== "production") {
  require("@/styles/styles.dev.css");
}

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
